import { useEffect, useState } from "react";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import { useSeo } from "@/lib/fmt";
import ProductCard from "@/components/store/ProductCard";

export default function Catalog() {
  const { slug } = useParams();
  const { pathname } = useLocation();
  const [sp] = useSearchParams();
  const { meta } = useStore();
  const [items, setItems] = useState(null);
  const q = sp.get("q") || "";
  const mode = pathname.startsWith("/necessidade") ? "need" : pathname.startsWith("/busca") ? "busca" : pathname.startsWith("/kits") ? "kits" : "cat";
  const cat = meta.categories.find((c) => c.slug === slug);
  const need = meta.needs.find((n) => n.chave === slug);
  const title = mode === "busca" ? (q ? `Resultados para "${q}"` : "Todos os produtos") : mode === "kits" ? "Kits" : mode === "need" ? need?.nome : cat?.nome;
  useSeo(title);
  useEffect(() => {
    const params = mode === "busca" ? (q ? { q } : {}) : mode === "kits" ? { categoria: "kits" } : mode === "need" ? { need: slug } : { categoria: slug };
    setItems(null);
    api.get("/products", { params }).then((r) => setItems(r.data));
  }, [mode, slug, q]);
  return (
    <div className="container-na pt-10">
      <p className="eyebrow">{mode === "need" ? "Necessidade" : mode === "busca" ? "Busca" : "Categoria"}</p>
      <h1 className="mt-2 text-4xl sm:text-5xl" data-testid="catalog-title">{title || "..."}</h1>
      {need?.nota && <p className="mt-3 text-na-ink2">{need.nota}</p>}
      {items && !items.length && <p className="mt-10 text-na-ink2" data-testid="catalog-empty">Não encontramos produtos. Tente outro termo.</p>}
      <div className="mt-8 grid grid-cols-2 gap-3 sm:gap-5 lg:grid-cols-4" data-testid="catalog-grid">
        {(items || []).map((p) => <ProductCard key={p.slug} p={p} />)}
      </div>
    </div>
  );
}
